export default __webpack_public_path__ + "media/images/dashboard_icons/message-6b4438c0a518936c15e23afea7800b86.svg";